import React, { useState, useEffect } from 'react'

import {
	Modal,
	Text,
	HStack,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Image,
} from '@chakra-ui/react'
import { useAuthContext } from '../../../../../../context/auth.context'
import { useLanguageContext } from '../../../../../../context/locale.context'
import { useSharedContext } from '../../../../../../context/shared.context'
import {
	useInviteParticipant,
	useAddTimelineUpdate,
} from '../../../../../../hooks/activity.hooks'
import { sharedConst } from '../../../../../../utils/action.constant'
import { sanitizeContent } from '../../../../../../utils/common.util'
import {
	formatDueDateForTimelineCurrDate,
	formatNoteUpdateDate,
} from '../../../../../../utils/date.utils'
import {
	GA_CATEGORY_WORKSPACE_PANEL,
	sectionDetailedTrack,
} from '../../../../../repository/repo.utils'
import ButtonCTA from '../../../../../../components/globalComponents/button'
import { loadAwsFile } from '../../../../../../utils/aws.util'
import defaultProfilePic from '../../../../../../assets/images/profile.png'
const ActivityJoinModal = ({ isOpen, onClose, activity }) => {
	const [profileImageData, setProfileImageData] = useState(null)
	const { mutate: inviteMutate } = useInviteParticipant()
	const { mutate: mutateTimelineUpdate } = useAddTimelineUpdate()
	const {
		state: { selectedQueue },
		dispatch,
	} = useSharedContext()
	const {
		state: { authData },
	} = useAuthContext()
	const {
		state: { locale },
	} = useLanguageContext()

	const onComment = ({ comment }) => {
		let payload = {
			content: sanitizeContent(comment),
			subject: 'Note - ' + formatNoteUpdateDate(),
			mail_body: sanitizeContent(comment),
			attachments: [],
			activity_reference: [{ activity_title: '', activity_id: '' }],
			asset_reference: [],
			form_approval_field_reference: [],
			is_reply: 0,
		}
		mutateTimelineUpdate(
			{
				operating_asset_first_name: authData.operating_asset_first_name,
				activity_id: activity.activity_id,
				activity_type_category_id: activity.activity_type_category_id,
				activity_type_id: activity.activity_type_id,
				// data_entity_inline: JSON.stringify(payload),
				activity_timeline_collection: JSON.stringify(payload),
			},
			{
				onSuccess: async data => {
					dispatch({
						type: sharedConst.REFRESH_TIMELINE,
					})
					onClose(true, true)
				},
			}
		)
	}

	const onHandleJoinAsParticipant = isLead => {
		inviteMutate(
			{
				is_lead: isLead,
				activity_id: activity.activity_id,
				activity_type_category_id: 48,
				activity_type_id: activity.activity_type_id,
				contact: {
					asset_type_id: authData.asset_type_id,
					asset_id: authData.asset_id,
					asset_first_name: authData.asset_first_name,
					operating_asset_first_name: authData.operating_asset_first_name,
					workforce_name: authData.authData,
				},
			},
			{
				onSuccess: async data => {
					let content = `${
						authData.operating_asset_first_name
					} joined at ${formatDueDateForTimelineCurrDate()}`
					if (isLead) {
						if (activity.activity_lead_operating_asset_first_name) {
							content = `Activity lead has been changed from
            "${activity.activity_lead_operating_asset_first_name}"
            to ${
							authData.operating_asset_first_name
						} at ${formatDueDateForTimelineCurrDate()}`
						} else {
							content = `${
								authData.operating_asset_first_name
							} join as Lead at ${formatDueDateForTimelineCurrDate()}`
						}
					}
					onComment({ comment: content })
				},
				onError: async data => {
					console.log('Error invite participant', data)
					onClose()
				},
			}
		)
	}
	useEffect(() => {
		setTimeout(() => {
			if (!!authData.asset_image_path) {
				loadAwsFile(authData.asset_image_path, d => {
					let data = 'data:' + d.type + ';base64,' + d.data
					setProfileImageData(data)
				})
			}
		}, 1000)
	}, [authData.asset_image_path, profileImageData])
	return (
		<Modal isOpen={true} onClose={onClose} size='lg'>
			<ModalOverlay />
			<ModalContent marginTop='75vh' marginLeft='55vw'>
				{/* <ModalHeader>{locale['Are you sure?']}</ModalHeader> */}

				{/* <ModalBody></ModalBody> */}
				<ModalFooter>
					<HStack justifyContent='space-between' alignItems='center'>
						{/* <Text mr="20px">
              {locale['Join']} &nbsp;
              {activity.activity_title}
            </Text> */}

						<Image
							src={profileImageData ? profileImageData : defaultProfilePic}
							h='48px'
							w='48px'
							borderRadius='10px'
						/>
						<Text>{authData?.operating_asset_first_name}</Text>
						{selectedQueue &&
						selectedQueue.hasOwnProperty('queue_flag_join_lead') &&
						!!selectedQueue.queue_flag_join_lead ? (
							<>
								<ButtonCTA
									variant='sidebarButton'
									children={locale['Join As Lead']}
									onClick={() => {
										sectionDetailedTrack({
											category: GA_CATEGORY_WORKSPACE_PANEL,
											action: 'Timeline Bottom Panel',
											label: 'Join As Lead',
										})
										onHandleJoinAsParticipant(1)
									}}
								/>
							</>
						) : (
							<>
								<ButtonCTA
									variant='sidebarButton'
									children={locale['Join As Lead']}
									onClick={() => {
										sectionDetailedTrack({
											category: GA_CATEGORY_WORKSPACE_PANEL,
											action: 'Timeline Bottom Panel',
											label: 'Join As Lead',
										})
										onHandleJoinAsParticipant(1)
									}}
								/>

								<ButtonCTA
									variant='sidebarButton'
									children={locale['Join As Participant']}
									style={{ marginRight: '2rem' }}
									mr='20px'
									onClick={() => {
										sectionDetailedTrack({
											category: GA_CATEGORY_WORKSPACE_PANEL,
											action: 'Timeline Bottom Panel',
											label: 'Join As Participant',
										})
										onHandleJoinAsParticipant(0)
									}}
								/>
							</>
						)}
						<ModalCloseButton
							color={'red.600'}
							style={{ marginTop: '1rem', marginLeft: '4rem' }}
						/>
					</HStack>
				</ModalFooter>
			</ModalContent>
		</Modal>
	)
}

export default ActivityJoinModal
